export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=709bf5e8474d9434f8694bf67aaea47d9da674d059&name=pushAdClickData!'